/** @jsx h */
import { h } from 'preact'

/**
 * Avatar
 *
 * A component that displays an image.
 *
 * See components/avatar.scss for all possible CSS class modifiers.
 *
 * TODO: Get rid of the <div>s. This should just be an <img> tag.
 *
 */
const Avatar = ({ url, altText, size }) =>
  <div class={`Avatar${size ? ` Avatar--${size}` : ''}`}>
    <div class='Avatar-inner'>
      <img src={url} class='Avatar-media' alt={altText} />
    </div>
  </div>

export default Avatar
